import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6689a0e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex p-flex-md-column" }
const _hoisted_2 = { class: "p-d-flex p-flex-md-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Message = _resolveComponent("Message")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Header)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view)
    ]),
    (_ctx.notification.length > 0 && _ctx.showNotification)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          severity: "success",
          closable: true,
          onClick: _ctx.hideNotification
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.notification), 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ], 64))
}